import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
// TODO: Descomentar cuando el backend implemente la funcionalidad de tamaño de paquete
// import StraightenOutlinedIcon from '@mui/icons-material/StraightenOutlined';
import { Icon, Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { MuiTelInput } from 'mui-tel-input';
import { Controller } from 'react-hook-form';

import Button from '@/components/Button';
import InputField from '@/components/InputField';

import { IEditProfile } from '../interfaces';

// TODO: Descomentar cuando el backend implemente la funcionalidad de tamaño de paquete
// import { getPackageWeight } from './utils';

const WithoutInvoice = ({
  register,
  errors,
  control,
  submitForm,
  shouldDisableEditing,
}: IEditProfile) => {
  const theme = useTheme();

  return (
    <Grid
      container
      spacing={2}
      direction="row"
      sx={{
        justifyContent: 'flex-end',
      }}
    >
      <Grid size={{ xxs: 12 }}></Grid>
      <Grid size={{ xxs: 12, md: 6 }}>
        <InputField
          disabled={shouldDisableEditing}
          label="Nombre comercial"
          name="company.name"
          errors={errors}
          register={register}
          icon={<StorefrontOutlinedIcon />}
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
        />
      </Grid>
      <Grid size={{ xxs: 12, md: 6 }}>
        <InputField
          disabled={shouldDisableEditing}
          label="Nombre Legal"
          name="company.legalName"
          errors={errors}
          register={register}
          icon={<StorefrontOutlinedIcon />}
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
        />
      </Grid>
      <Grid size={{ xxs: 12, md: 6 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', margin: '1rem 0.5rem 0.5rem 0' }}>
          <Icon color="disabled" sx={{ marginRight: '0.5rem' }}>
            <PhoneIphoneOutlinedIcon />
          </Icon>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              color: theme.palette.secondary.main,
              fontSize: '1rem',
            }}
          >
            Teléfono
          </Typography>
        </Box>
        <Controller
          name="company.phone"
          control={control}
          render={({ field }) => (
            <MuiTelInput
              sx={{ width: '100%' }}
              onlyCountries={['MX', 'PE', 'CO', 'CL']}
              defaultCountry="MX"
              disabled={shouldDisableEditing}
              error={!!(errors?.company as any)?.phone}
              helperText={(errors?.company as any)?.phone?.message}
              {...field}
              onChange={(e) => {
                field.onChange(e.replace(/\s/g, ''));
              }}
            />
          )}
        />
      </Grid>
      <Grid size={{ xxs: 12, md: 6 }}>
        <InputField
          disabled={shouldDisableEditing}
          label="Email"
          name="company.email"
          errors={errors}
          register={register}
          icon={<EmailOutlinedIcon />}
          sxInput={{ mt: 0 }}
          sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
        />
      </Grid>
      {/* TODO: Descomentar cuando el backend implemente la funcionalidad de tamaño de paquete */}
      {/* <Grid size={{ xxs: 12, md: 6 }}>
        <Controller
          name="company.packageSize"
          control={control}
          render={({ field }) => (
            <SelectField
              label="Tamaño de paquete"
              errors={errors}
              options={getPackageWeight(profile.data?.country || 'MEX')}
              sxLabel={{ color: theme.palette.secondary.main, fontSize: '1rem' }}
              icon={<StraightenOutlinedIcon />}
              {...field}
            />
          )}
        />
      </Grid> */}
      {!shouldDisableEditing && (
        <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%', marginTop: '1rem' }}>
          <Button
            onClick={() => submitForm?.('company')}
            disabled={Object.entries(errors.company! ?? {}).length > 0}
          >
            Actualizar datos
          </Button>
        </Box>
      )}
    </Grid>
  );
};

export default WithoutInvoice;
